import SiteHeader from './components/site-header';
import NewsSlider from './components/news-slider';
import ImageHotspotsSelector from './components/image-hotspots-selector';
//import HandheldMenu from "./components/handheld-menu";
import RechercheLoadMore from "./components/recherche-load-more";
import ActualiteLoadMore from "./components/actualite-load-more";
import DossierLoadMore from "./components/dossier-load-more";
import ThematicSearch from "./components/thematic-search";
import SocialShare from "./components/social-share";
import SupportItemsForm from "./components/support-items-form";
import CookiesConsent from "./components/cookies-consent";
import Accordion from "./components/accordion";

import DeviceManager from './utils/device-manager';

(function($) {
    window.$ = $;

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // Handheld menu
        //const handheldMenu = new HandheldMenu();

        // General components
        const siteHeader = new SiteHeader($('.site-header'), 20);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

        // News slider component
        const $newsSliders = $('.news-slider');
        if($newsSliders.length) {
            $newsSliders.each(function(index, el) {
                const newsSlider = new NewsSlider($(el));
            });
        }

        // Dossier load more component
        const $dossierLoadMoreBtns = $('.dossier-load-more');
        if($dossierLoadMoreBtns.length) {
            $dossierLoadMoreBtns.each(function(index, el) {
                const dossierLoadMore = new DossierLoadMore($(el));
            });
        }

        // Actualite load more component
        const $actualiteLoadMoreBtns = $('.actualite-load-more');
        if($actualiteLoadMoreBtns.length) {
            $actualiteLoadMoreBtns.each(function(index, el) {
                const actualiteLoadMore = new ActualiteLoadMore($(el));
            });
        }

        // Recherche load more component
        const $rechercheLoadMoreBtns = $('.recherche-load-more');
        if($rechercheLoadMoreBtns.length) {
            $rechercheLoadMoreBtns.each(function(index, el) {
                const rechercheLoadMore = new RechercheLoadMore($(el));
            });
        }

        // Tags search component
        const $thematicSearch = $('.thematic-search');
        if($thematicSearch.length) {
            const thematicSearch = new ThematicSearch($thematicSearch);
        }

        // Social share component
        const $socialShares = $('.social-share');
        if($socialShares.length) {
            $socialShares.each(function(index, el) {
                const socialShare = new SocialShare($(el));
            });
        }

        // Support item component
        const $supportItemsForm = $('.supports-command-form');
        if($supportItemsForm.length) {
            const supportItemsForm = new SupportItemsForm($supportItemsForm);
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = 'fr';
            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }
    });

    if (window.matchMedia("(max-width: 991px)").matches) {
      $('.slider-mobile').flickity({
        autoPlay: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false
      });
    }

    $('.menu-toggler').click(function() {
      $(this).prev('.handheld-header__nav-wrapper').toggleClass('opened');
      $(this).toggleClass('close');
    });

    /*if( $('.list-supports__categories input[type="checkbox"]').is(':checked') ){
      var checkboxID =
      $('list-supports__items').find('.support-item').each(function(){
        if($(this))
      });
    }*/

    //Tri des supports selon la catégorie
    $('.list-supports__categories input[type="checkbox"]').click(function () {
      var checkbox = $(this);
      var checkboxID = checkbox.attr('id');
        if ( checkbox.is(':checked') ) {
          checkbox.parent('.button').addClass('active');
          $('.support-item').each(function(i){
            if( !$(this).hasClass(checkboxID) ) {
              $(this).css('display', 'none');
            }
          });
        } else {
          checkbox.parent('.button').removeClass('active');
          $('.support-item').each(function(i){
            if( !$(this).hasClass(checkboxID) ) {
              $(this).css('display', 'flex');
            }
          });
        }
    });

    $('.list-supports__icon-cart input[type="checkbox"]').click(function () {
      var checkbox = $(this);
        if ( checkbox.is(':checked') ) {
          $('.cart').removeClass('hidden');
          $('.list-supports').addClass('hidden');
        } else {
          $('.cart').addClass('hidden');
          $('.list-supports').removeClass('hidden');
        }
    });

    var $mobileMenu = $('#mobile-menu');
    if($mobileMenu.length) {
        $mobileMenu.prepend('<li class="menu-item"><a href="/">Accueil</a></li>');
    }

  // if($('body.search-results .list-search-results').children().length > 6){

  //   var divs = $(".list-search-results__item");
  //   for(var i = 0; i < divs.length; i+=6) {
  //     divs.slice(i, i+6).wrapAll("<div class='list-search-results__group'></div>");
  //   }

  //   $('.list-search-results__group:not(:first-of-type)').hide();

  //   var count = 1;
  //   $('body.search-results .load-more').click(function() {
  //     count++;
  //     var group = $('.list-search-results__group:nth-of-type(' + count + ')');
  //     group.show();
  //     if(group.is(':last-of-type')) {
  //       $('body.search-results .load-more').hide();
  //     }
  //   });
  // } else {
  //   $('body.search-results .load-more').hide();
  // }


})(jQuery);
